import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TrendChart = ({ trends }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date?.getMonth() + 1}/${date?.getDate()}`;
  };

  const chartData = trends?.map(trend => ({
    ...trend,
    date: formatDate(trend?.date)
  }));

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Alert Trends (Last 7 Days)</h3>
      
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }}
          />
          <YAxis 
            tick={{ fontSize: 12 }}
          />
          <Tooltip />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="audit" 
            stroke="#9333ea" 
            strokeWidth={2}
            name="Audit Events"
          />
          <Line 
            type="monotone" 
            dataKey="compliance" 
            stroke="#eab308" 
            strokeWidth={2}
            name="Compliance"
          />
          <Line 
            type="monotone" 
            dataKey="environmental" 
            stroke="#22c55e" 
            strokeWidth={2}
            name="Environmental"
          />
          <Line 
            type="monotone" 
            dataKey="total" 
            stroke="#3b82f6" 
            strokeWidth={2}
            strokeDasharray="5 5"
            name="Total"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendChart;